import { ExternalLink } from '@approvalmax/ui';
import { selectors } from 'modules/common';
import { getLockDateInEffect } from 'modules/common/selectors/requestSelectors.QBooks';
import { domain } from 'modules/data';
import { NotSyncedIcon } from 'modules/sprites';
import { font } from 'modules/styles';
import moment from 'moment';
import { FC, memo } from 'react';
import styled from 'styled-components';

import { messages } from './QBooksPendingStatusToolbarSection.messages';

const Container = styled.div`
    flex: none;
    display: flex;
    align-items: center;
    padding: 19px 60px;
    background: #f7f7f7;
`;

const StyledIcon = styled(NotSyncedIcon)`
    margin-right: 15px;
`;

const Text = styled.div`
    ${font(13, '#737373')}
    white-space: pre-line;
    flex: 1;
`;

const DEFAULT_URL_IN_LOCK_MSG = 'https://app.qbo.intuit.com/app/accountsettings?p=advanced';

type QBooksPendingStatusToolbarSectionProps = {
    request:
        | selectors.types.QBooksBillExpandedRequest
        | selectors.types.QBooksPoExpandedRequest
        | selectors.types.QBooksInvoiceExpandedRequest
        | selectors.types.QBooksExpenseExpandedRequest
        | selectors.types.QBooksJournalEntryExpandedRequest;
};

const QBooksPendingStatusToolbarSection: FC<QBooksPendingStatusToolbarSectionProps> = (props) => {
    const { request } = props;
    const details = request.details;
    const lockDateInEffect = getLockDateInEffect(details);

    const formatIssues = (issues: string[]) => {
        const isManager = request.company.flags.isManager;

        if (isManager) {
            return messages.requestAmBlockedValidationErrorManager({
                br: <br />,
                issues: issues.join(', '),
                qBooksLink: (
                    <ExternalLink href={DEFAULT_URL_IN_LOCK_MSG}>
                        {request.company.integration?.displayName}
                    </ExternalLink>
                ),
            });
        } else {
            return messages.requestBlockedValidationErrorUser({
                issues: issues.join(', '),
                br: <br />,
                qBooksLink: (
                    <ExternalLink href={DEFAULT_URL_IN_LOCK_MSG}>
                        {request.company.integration?.displayName}
                    </ExternalLink>
                ),
            });
        }
    };

    const getIssues = () => {
        const issues = [];
        const hasIssue =
            lockDateInEffect &&
            details.lockDatePolicy === domain.TemplateSettingsLockDatePolicy.LockApproval &&
            [
                domain.RequestStatusV2.OnApproval,
                domain.RequestStatusV2.OnHold,
                domain.RequestStatusV2.Rejected,
            ].includes(request.statusV2);

        if (hasIssue) {
            issues.push(
                messages.validationErrorTextLockDateInEffect({
                    lockDate: moment(details.lockDate!).format('LL'),
                })
            );
        }

        return issues.length > 0 ? formatIssues(issues) : null;
    };

    const issues = getIssues();

    if (!issues) return null;

    return (
        <Container>
            <StyledIcon width={21} height={22} />

            <Text>{issues}</Text>
        </Container>
    );
};

export default memo(QBooksPendingStatusToolbarSection);
